const pl = {
  system: {
    total: "razem",
    rm: "usuń",
    desc: "Brak danych",
    cancel: "anuluj",
    confirm: "potwierdź",
    ondel_address_title: "Czy na pewno chcesz usunąć ten adres?",
    rules_message: "Proszę wprowadzić",
    message_success: "Sukces",
    message_warning: "niepowodzenie",
    myorder: "Moje zamówienie",
    changePassword: "Zmień hasło",
    logout: "wyloguj się",
    code: "Kod potwierdzający",
    yes: "TAK",
    no: "NIE",
    rm_message: "Ta operacja usunie rekord. Czy chcesz kontynuować?",
    rm_title: "Ostrzeżenie",
    rm_ok: "Potwierdź",
    rm_cancel: "Anuluj",
    language: "Język",
    signIn: "Zaloguj się",
    email: "E-mail",
    password: "Hasło",
    confirmPassword: "Potwierdź",
    noOrder: "Brak zamówień",
    normalMember: "Zwykły użytkownik"
  },
  home: {
    title: "Nasze bestsellery",
    memberCoupon: {
      title: "Oferta dla nowych użytkowników",
      desc: "Zarejestruj się i otrzymaj 10% rabatu na pierwsze zamówienie",
      action: "Zarejestruj się",
      shopAction: "Przejdź do sklepu",
    },
    tit0: {
      title: "Sprawdź dostępność tutaj za darmo już teraz",
    },
    tit1: {
      title: "Indywidualne rozwiązania transformatorowe do 400 kV",
      text: "Niezależnie od tego, czy to transformator dystrybucyjny, energetyczny czy specjalne rozwiązanie: oferujemy indywidualne transformatory dla średnich i wysokich napięć zgodnie z wymaganiami Twojej sieci.",
      button: "Odkryj produkty transformatorowe",
    },
    tit2: {
      title: "Optymalne rozwiązania dla dostawców energii i dużych projektów",
      text: "Nasze zakłady produkcyjne w Chinach umożliwiają wysoką wydajność — na przykład do 1000 transformatorów średniego napięcia miesięcznie. W połączeniu z dobrze zorganizowaną logistyką oferujemy konkurencyjne terminy dostaw.",
      button: "Nasz wybór",
    },
    wsc_tit1: "Dlaczego powinieneś nas wybrać",
    wsc_tit2: "Nasi partnerzy współpracy",
    wsc_tit3: "Życie codzienne z energią odnawialną",
    wsc_tit4: "Aktualizacje firmowe do podzielenia się z Tobą",
    wsc_tit5: "Więcej",
    wsc_sub1: "Nasze produkty spełniają najwyższe międzynarodowe standardy jakości i bezpieczeństwa",
    wsc_sub2: "Zaufaj naszym silnym partnerstwom z wiodącymi firmami w branży energetycznej",
    wsc_sub3: "Bądź na bieżąco z najnowszymi wydarzeniami i projektami",
    services_title: "Nasze usługi",
    services_sub: "Rozwiązania dopasowane do Twoich projektów energetycznych",
    readMore: "Czytaj dalej",
    learnMore: "Dowiedz się więcej",
    box1: "Rozdzielnice",
    box1_desc: "Wydajne rozdzielnice wysokiego napięcia bez SF₆.",
    box2: "Transformator",
    box2_desc: "Wydajne transformatory dla sieci wysokiego napięcia.",
    box3: "Kabel średniego napięcia",
    box3_desc: "Niezawodne rozwiązania połączeń dla dystrybucji energii.",
  },
  banner: {
    title: "Wspieranie energii odnawialnej",
  },
  footer: {
    p1: "Infolinia konsultacyjna：",
    p2: "Kontakt",
    p3: "Niemcy",
    p5: "Wyświetlenia",
    avis1: "Darmowy transport",
    avis2: "Opcje płatności",
    search: {
      tit: "Zapisz się i skontaktuj z nami już teraz!",
      button: "Subskrypcja",
      t1: "Zgadzam się z",
      t2: " Warunkami użytkowania ",
      t3: "oraz",
      t4: "Polityką prywatności",
    },
    navList: {
      name1: "o nas",
      children1: {
        name1: "Wsparcie zespołu",
      },
      name2: "Wsparcie",
      children2: {
        name2: "Nasza karta ekologiczna",
      },
    },
  },
  pay: {
    item1: "Strona główna",
    item2: "Centrum produktów",
    item3: "Informacje o produkcie",
    item4: "Płatność",
    label1: {
      title: "Informacje kontaktowe",
      text: "Masz już konto?",
      el: "Zaloguj się",
      input: "Proszę wybrać adres",
      tip: "Proszę dodać adres",
    },
    label2: {
      title: "Adres dostawy",
      input1: "Imię i nazwisko",
      input2: "Inne informacje adresowe",
      input3: "Kod pocztowy",
      input4: "Miasto",
      input5: "Telefon",
    },
    info: {
      pro_info: "Informacje o produkcie",
      type1: "DC Trans Logistik & Trade GmbH",
      type2: "Eisenstrasse 30, 65428 Rüsselsheim",
      type3: "Deutsche Postbank Ndl",
      span1: "Darmowa wysyłka",
      span2: "Serwis na całe życie",
      span3: "Bez pytań. Gwarancja producenta",
    },
    button: "Do kasy",
    products: {
      message_error: "Błąd parametru!",
    },
    validate: {
      message1: "Proszę wybrać adres dostawy",
      message2: "Proszę wybrać adres do faktury",
      message3: "Proszę zaakceptować regulamin",
    },
    addOrder: {
      message_success: "Zamówienie złożone pomyślnie",
      message_warning: "Nie udało się dodać zamówienia",
    },
    notice:
      "Uwaga: Upewnij się, że Twoje nazwisko jest na dzwonku, a jeśli jest kontrola dostępu lub trzeba przekazać komuś, w przeciwnym razie może nie zostać dostarczone. Dla bezpieczeństwa przesyłki prosimy o oddzielenie przedmiotów ze szkła.",
    transfer: {
      text1:
        "Proszę przelać kwotę faktury na nasze konto bankowe. Otrzymasz powiadomienie o potwierdzeniu zamówienia e-mailem z danymi bankowymi i numerem zamówienia",
      text2: "pieniądze",
      text3: "Nazwa właściciela konta",
      text4: "Proszę podać te dane",
      text5: "Numer konta bankowego",
      text6: "Adres kontaktowy odbiorcy",
      text7: "Nazwa banku",
      text8: "Zgadzam się z regulaminem",
      text9: "warunki świadczenia usług",
    },
    result: {
      text1: "Płatność została zrealizowana pomyślnie. Twoje zamówienie jest przetwarzane i przygotowywane do wysyłki.",
      text2: "numer zamówienia",
      text3: "sposób płatności",
      text4: "przelew bankowy",
      text5: "kwota płatności",
      fail_text: "Płatność nie powiodła się. Spróbuj ponownie lub wybierz inną metodę płatności.",
      cancle_text: "Płatność została anulowana. Twoje zamówienie nie zostało zrealizowane.",
      loading_text: "Potwierdzanie płatności, proszę czekać...",
    },
    button2: "Powrót do strony głównej",
    button3: "Szczegóły zamówienia",
    type: "rodzaj transportu",
    pay_info:
      "DHL Global Express Niemcy dostawa do domu / odbiór w punkcie powyżej 39 euro darmowa dostawa",
    pay_info_days: "2-4 dni robocze",
    pay_way: "sposób płatności",
    pay_type: "Płatność przelewem bankowym",
    eur: "(Od 3999 €)",
    pay_desc:
      "Dodając swoje konto bankowe, upoważniasz Amazon do wysyłania instrukcji do Twojego banku w celu obciążenia Twojego konta. Upoważniasz również swój bank do obciążenia konta zgodnie z tymi instrukcjami. Możesz zażądać zwrotu w ciągu 8 tygodni od daty obciążenia. Obowiązują warunki uzgodnione z Twoim bankiem.",
    pay_save: "Zapisz na przyszłe zakupy",
    pay_info_pay:
      "Twoje dane płatnicze są szyfrowane i bezpieczne.<br />Zapisanie metody płatności na przyszłość pomoże Ci szybciej finalizować zakupy.",
    pay_more: "Dowiedz się więcej",
    add_bank: "Dodaj konto bankowe",
  },
  pay2: {
    freeShipping: 'Darmowa dostawa',
    text1: 'Dane kontaktowe',
    text2: 'Sposób dostawy',
    text3: 'Metoda płatności',
    text4: 'Finalizacja zamówienia',
    text5: "Adres dostawy",
    text6: "Adres rozliczeniowy",
    text7: "Edytuj",
    text8: "Inny adres dostawy",
    text9: "Czas dostawy 2-3 dni robocze",
    text10: "Dostawa z:",
    text11: 'Nie masz jeszcze zapisanego adresu dostawy',
    text12: 'Punkt odbioru',
    text13: 'Przejdź do punktu logistycznego',
    btn1: "Kontynuuj",
    btn2: "Kontynuuj",
    btn3: 'Dodaj adres dostawy',
    btn4: 'Wybierz adres dostawy',
    btn5: 'Kup teraz',
    tit1: 'Moje dane',
    tit2: 'Twój adres rozliczeniowy',
    tit3: 'Wybierz adres dostawy?',
    tit4: 'Adres dostawy',
    tit5: 'Wybierz metodę płatności?',
    tit6: 'Koszyk',
    option1: 'PayPal',
    option2: 'Karta kredytowa',
    msg1: 'Dzięki PayPal płacisz wygodnie i bezpiecznie. Po założeniu konta PayPal płacisz tylko za pomocą adresu e-mail i hasła. Odbywa się to po zakończeniu zamówienia.',
    msg2: 'Pozostała kwota faktury zostanie pobrana z konta karty kredytowej po wysłaniu zamówienia. Dane karty kredytowej wprowadzasz po zakończeniu zamówienia.',
    msg3: 'Łącznie z VAT.',
    submitOrder: 'Czy chcesz sfinalizować to zamówienie?'
  },
  address: {
    txt: "Adresy dostawy",
    p: "Uwaga: Adresy dostawy można edytować lub dodać podczas finalizacji zamówienia.",
    button: "Dodaj nowy adres",
    tag: "Standardowy",
    onEdit: "Edytuj",
    form: {
      name: "Imię",
      phone: "Numer telefonu",
      address: "Adres",
      company: 'Numer domu/Mieszkanie/Nazwa firmy, C/O',
      street: 'Ulica',
      number: 'Nr',
      number_tip: 'Jeśli nie ma numeru ulicy, zastąp znakiem "-"',
      postal_code: "Kod pocztowy",
      city: "Miasto",
      country: "Kraj",
      checkbox: "Ustaw jako domyślny adres",
      checkbox2: "Adres jest również używany jako adres rozliczeniowy",
      onSubmit: "Dodaj adres",
      default: 'Domyślny',
    },
    rules: {
      message: "To pole jest wymagane",
    },
    dialog_tiltle: "Dodaj nowy adres",
    name: "adres",
    shipping: "Dodaj adres dostawy",
    bill: "adres rozliczeniowy",
  },
  clause: {
    onClose: "Odrzuć wszystko",
    acceptAll: "Akceptuj wszystko",
    class1: "Szanujemy Twoją prywatność",
    class2: "Używamy plików cookie, aby poprawić jakość przeglądania, dostarczać spersonalizowane treści i analizować ruch na stronie. Klikając \u201EAkceptuj wszystko\u201D, wyrażasz zgodę na używanie plików cookie. Więcej informacji znajdziesz w naszej",
    class3: "",
    class4: "Polityce plików cookie",
    text4: "",
    class5: "Funkcjonalne",
    class6: "Pliki cookie do analizy i poprawy wydajności strony oraz doświadczenia użytkownika.",
    class7: "Marketing",
    class8: "Pliki cookie do spersonalizowanej reklamy na platformach partnerskich.",
    onAccept: "Akceptuj wszystko",
    class10: "Zarządzaj preferencjami",
    br2: "Polityka plików cookie",
    class11: "Impressum",
    msg1: "Ustawienia plików cookie",
    msg2: "Wybierz, które pliki cookie chcesz zezwolić.",
    msg3: "Marketing",
    msg4: "Umożliwia spersonalizowaną reklamę na platformach partnerskich, takich jak Google i sieci społecznościowe.",
    msg5: "Funkcjonalne",
    msg6: "Umożliwia analizę w celu poprawy wydajności strony i doświadczenia użytkownika.",
    msg7: "Możesz wycofać swoją zgodę w dowolnym momencie w Ustawieniach plików cookie. Bez wyboru używane będą tylko wymagane pliki cookie.",
    msg8: "Potwierdź wybór",
    required: "Wymagane",
    alwaysActive: "Zawsze aktywne",
  },
  order: {
    item1: "Strona główna",
    item2: "Moje zamówienie",
    tip: "Proszę przesłać potwierdzenie przelewu",
    upload1: "prześlij",
    remittance: "Potwierdzenie przelewu:",
    wmsInfo: "Numer dostawy:",
    select: "Status zamówienia",
    produces: "Lista produktów",
    state: {
      label1: "Nieopłacone",
      label2: "Opłacone",
      label3: "Wysłane",
      label4: "Zakończone",
    },
    refund: {
      title: "Zloz wniosek o zwrot",
      orderNo: "Numer zamowienia",
      amount: "Kwota zwrotu",
      reason: "Powod zwrotu",
      reasonPlaceholder: "Wybierz lub wpisz powod",
      description: "Opis",
      descriptionPlaceholder: "Dodaj wiecej szczegolow dla sprzedawcy",
      evidence: "Zdjecie dowodowe",
      upload: "Przeslij zdjecie",
      submit: "Wyslij wniosek",
      reasonRequired: "Wybierz lub wpisz powod zwrotu.",
      reasonMax: "Powod zwrotu nie moze przekraczac 255 znakow.",
      reasons: {
        productIssue: "Problem z produktem",
        wrongItem: "Niewlasciwy produkt",
        qualityProblem: "Problem z jakoscia",
        other: "Inne",
        addressWrong: "Bledny adres dostawy",
        notAsDescribed: "Niezgodne z opisem",
        infoWrong: "Bledne dane",
        reorder: "Zloz nowe zamowienie",
        damaged: "Produkt dotarl uszkodzony",
        delayedOther: "Nie wyslano na czas lub inny powod",
      },
    },
  },
  product: {
    item1: "Strona główna",
    item2: "Centrum produktów",
    class: "SZUKAJ",
    info: "Zarejestruj się, aby uzyskać więcej rabatów",
    label: "Połączenie internetowe",
    prefixPrice: "Od ",
    suffixPrice: "",
    detail: {
      scrollTo1: "Zapłać",
      scrollTo2: "Specyfikacje",
      item1: "Strona główna",
      item2: "Centrum produktów",
      label: "Specyfikacja",
      Menge: "Ilość",
      label1: "Sposób wysyłki",
      wsc_title1: "Opis",
      wsc_title2: "Cechy",
      wsc_title3: "Szczegóły techniczne",
      class1: "Dodaj do koszyka",
      class2: "Kup teraz",
      dowload_tit: "Pobierz",
      dowload1: "Instrukcja instalacji",
      dowload2: "Inne dokumenty",
      dowload3: "Instrukcja obsługi",
      dowload4: "Podręcznik zapewnienia jakości",
      dowload5: "Karta katalogowa",
      message: "Dodano pomyślnie",
      message2: "Produkt już znajduje się w koszyku, nie trzeba dodawać ponownie",
      params: "Parametry produktu",
      weight: "Waga",
      dimensions: "Wymiary",
      inStock: "W magazynie",
      outOfStock: "Brak w magazynie",
      vat: "(brutto)",
      downloadTitle: "Pobieranie danych",
      chooseLang: "Wybierz swój język",
      global: "Globalny",
      fileName: "Nazwa pliku",
      fileLanguage: "Język",
      fileFormat: "Format",
      fileSize: "Rozmiar",
      fileUpdated: "Ostatnia aktualizacja",
      fileDownload: "Pobierz",
      noDocs: "Nie znaleziono dokumentów."
    },
    checkOption: {
      label1: "Połączenie internetowe",
    },
  },
  news: {
    item1: "Strona główna",
    item2: "Aktualności",
    item3: "Aktualności i trendy",
    item4: "Szczegóły aktualności",
    item5: "Czas publikacji",
    text1: "OSS · Aktualności i trendy",
    text2: "Więcej",
    text3: "Poprzedni artykuł",
    text4: "Następny artykuł",
  },
  shop: {
    item1: 'Strona główna',
    item2: 'Mój koszyk',
    tit1: "Mój koszyk",
    tit2: "Przedmioty",
    button: "Złóż zamówienie",
    tit3: 'Koszty wysyłki',
    tit4: 'Kwota faktury',
    tit5: 'Kwota do zapłaty',
    tit6: 'VAT i wysyłka nie są wliczone',
    summary: 'Podsumowanie zamówienia',
    subtotal: 'Suma częściowa',
    free: 'Bezpłatnie',
    pendingShipping: 'Do obliczenia',
    continue: 'Kontynuuj zakupy',
  },
  solution: {
    tit: "O nas",
    tit1:
      "Chcemy, aby program Oss Energy dostarczał zrównoważone rozwiązania energetyczne, które chronią środowisko i spełniają potrzeby naszych klientów. Dzięki wieloletniemu doświadczeniu i zaangażowanemu zespołowi ekspertów dążymy do uczynienia świata bardziej zielonym i czystszym miejscem.",
    tit2:
      "Nasze usługi obejmują instalację i dostarczanie wysokiej jakości elektrowni słonecznych zarówno dla klientów indywidualnych, jak i komercyjnych. Dostosowujemy się do potrzeb, do indywidualnych wymagań i potrzeb. Od wczesnych konsultacji, przez projektowanie i instalację, po regularną konserwację i monitorowanie, zapewniamy płynne i efektywne wykorzystanie energii słonecznej.",
    tit3:
      "Nasze zaangażowanie w jakość i zrównoważony rozwój jest sercem naszego planu biznesowego. Ściśle współpracujemy z klientami, aby zapewnić optymalne działanie i maksymalną wydajność elektrowni słonecznych. Jesteśmy dumni, że dostarczamy naszym klientom tanią energię i długoterminowe oszczędności.",
    wsc_title1: "Seria produktów",
    tit4:
      "Chcemy, aby program Oss Energy dostarczał zrównoważone rozwiązania energetyczne, które chronią środowisko i spełniają potrzeby naszych klientów. Dzięki wieloletniemu doświadczeniu i zaangażowanemu zespołowi ekspertów dążymy do uczynienia świata bardziej zielonym i czystszym miejscem. Skontaktuj się z nami już teraz pod numerem +49 69 71585988 lub kliknij Dowiedz się więcej.",
    btn: "Dowiedz się więcej",
    wsc_title2: "Nasza przewaga",
    tit5:
      "Moduły solarne Tongwei z technologią dachówkową są mocniejsze i piękniejsze niż tradycyjne moduły solarne, a także pozwalają na bardziej efektywne wykorzystanie energii słonecznej, zwiększając wydajność produkcji energii.",
    wsc_title3: "Rozwiązanie",
    tit6:
      "W oss energy skupiamy się nie tylko na jakości i wydajności naszych produktów, ale także na doskonałej obsłudze klienta. Nasz doświadczony zespół instaluje Twoją instalację zgodnie ze standardami branżowymi i zapewnia kompleksową obsługę posprzedażową, aby zapewnić długoterminową eksploatację i konserwację. Skupiamy się na Twoich potrzebach i zapewniamy niezawodne rozwiązania oraz wsparcie techniczne.",
    tit7: "Rozwiązanie 1: Nie masz jeszcze systemu fotowoltaicznego",
    tit8:
      "Oferujemy dostosowane do potrzeb rozwiązania zielonej energii o wysokiej rentowności i długoterminowej gwarancji. Na podstawie indywidualnego zużycia energii projektujemy ekonomiczny plan energetyczny, aby zapewnić najszybszy zysk. Nasze wysokiej jakości produkty maksymalizują czas uzysku.",
    tit9:
      "Rozwiązanie 2: Masz już system fotowoltaiczny, ale potrzebujesz magazynu",
    tit10:
      "Nasze szybkie rozwiązanie magazynowania fotowoltaicznego pozwala na podłączenie systemu magazynowania baterii bez ponownej zgody na podłączenie do sieci lub demontażu istniejącego systemu. Dzięki zastosowaniu serii inwerterów FIT osiągamy wydajne połączenie między baterią a istniejącym systemem fotowoltaicznym. Oszczędzasz czas i zwiększasz wskaźnik autokonsumpcji dzięki szybkiemu wdrożeniu wydajnego systemu magazynowania.",
    wsc_title4: "Wyróżnienia",
    tit11:
      "Moduły fotowoltaiczne Tongwei zostały dodane do listy Tier-1 globalnych modułów wybranych przez Bloomberg New Energy Finance spośród Top 10. (IV kwartał 2022 i I kwartał 2023)",
    tit12:
      "SolaX zdobył nagrodę „Best Commercial Inverter” na UK Solar Power Portal Awards, nagrodę „Best Battery Energy Storage System” na Australian Intersolar Awards oraz nagrody UK Top Inverter i Top Battery od niemieckiego EUPD Research",
    item1: "Lista Tier-1",
    item2: "Najlepsze inwertery w Wielkiej Brytanii",
    item3: "Top-BESS w Australii",
    item4: "Najlepszy inwerter i bateria w Wielkiej Brytanii i DE",
    item5: "ECS",
    wsc_title5: "Zalety produktu",
    wsc_title6: "Dla gospodarstw domowych",
    li1: "Zakres mocy: Specjalizujemy się w dostarczaniu systemów fotowoltaicznych o mocy od 6 do 30 kWp, idealnych dla potrzeb energetycznych gospodarstw domowych.",
    li2: "Indywidualne rozwiązania: Nasze dostosowane rozwiązania fotowoltaiczne płynnie integrują się z indywidualnymi potrzebami energetycznymi i warunkami przestrzennymi.",
    li3: "Efektywny montaż: Nasi eksperci zapewniają szybką i bezproblemową instalację, która płynnie integruje się z otoczeniem domowym.",
    li4: "Opłacalność i dotacje: Pomagamy klientom osiągnąć maksymalne korzyści finansowe, w tym oszczędności na kosztach energii i dotacje rządowe.",
    li5: "Prosta konserwacja: Nasze systemy PV wymagają niewielkiej konserwacji i zapewniają niezawodne oraz wydajne zasilanie.",
    li6: "Zgodność: Gwarantujemy zgodność ze wszystkimi lokalnymi przepisami budowlanymi i wymogami prawnymi.",
    wsc_title7: "Dla firm",
    li7: "Zakres mocy: Dla firm oferujemy kompleksowe rozwiązania PV o mocy do 2 bilionów kWp, zaprojektowane dla wysokich wymagań energetycznych działalności komercyjnej i przemysłowej.",
    li8: "Duże projekty PV: Nasze systemy są skalowalne i mogą być elastycznie dostosowywane do złożonych struktur operacyjnych.",
    li9: "Zaawansowane systemy zarządzania energią: Integrujemy systemy PV z istniejącymi strukturami zarządzania energią, oferując innowacyjne rozwiązania w zakresie generowania, magazynowania i zarządzania energią.",
    li10: "Kompleksowe doradztwo i zgodność: Nasz doświadczony zespół pomaga w poruszaniu się po złożonych przepisach, zapewniając zgodność i efektywność operacyjną.",
    li11: "Długoterminowe zwroty z inwestycji: Pomagamy firmom osiągać długoterminowe korzyści finansowe i ekologiczne.",
    li12: "Profesjonalna konserwacja i monitorowanie: Zapewniamy zaawansowane usługi, aby zmaksymalizować wydajność systemów PV.",
    bTitle1: "NASZE PROJEKTY DOMOWE",
    bTitle2: "NASZE PROJEKTY KOMERCYJNE",
    bTip: "SPRAWIAMY, ŻE TWOJE DOMY SĄ BARDZIEJ ZIELONE!",
    bTip2: "SPRAWIAMY, ŻE TWOJA FIRMA JEST BARDZIEJ ZIELONA!",
  },
  login: {
    login_name: "Zaloguj się",
    register_name: "Zarejestruj się",
    code: "Kod weryfikacyjny",
    login_tit: "Ciesz się najlepszym doświadczeniem",
    tit: "Po prostu zaloguj się i śledź zamówienia, dostosuj ustawienia i korzystaj z ekskluzywnych ofert.",
    tit1: "Wprowadź dane rejestracyjne i zaloguj się, aby zobaczyć informacje o rabatach po rejestracji",
    tit2: "Masz już konto, zapomniałeś hasła?",
    form: {
      name: "Imie i nazwisko",
      namePlaceholder: "Wprowadz imie i nazwisko",
      email: "E-Mail",
      emailPlaceholder: "twoj-email@example.com",
      password: "Haslo",
      passwordPlaceholder: "Wprowadz haslo",
      createPasswordPlaceholder: "Utworz silne haslo",
      confirmPassword: "Potwierdz haslo",
      confirmPasswordPlaceholder: "Powtorz haslo",
      code: "Kod weryfikacyjny",
      codePlaceholder: "Wprowadz kod",
    },
    checkEmail: {
      tit1: "E-mail nie może być pusty",
      tit2: "Proszę wprowadzić adres e-mail.",
    },
    validatePass2: {
      tit1: "Proszę wprowadzić hasło ponownie",
      tit2: "Wprowadzone hasła nie są zgodne!",
    },
    password: {
      message: "Hasło musi zawierać od 8 do 16 znaków",
      tit: "Nie może być takie samo jak nazwa użytkownika",
    },
    checkCode: {
      tit: "Kod weryfikacyjny jest pusty",
    },
    content: "Proszę wprowadzić kombinację liter i cyfr",
  },
  resetPwd: {
    name: "Resetuj hasło",
    reset: "Resetuj",
    login: "Zaloguj się",
    tit1: "Potwierdź e-mail",
    tit2: "Ustaw hasło",
    tit3: "Zakończ",
    next: "Dalej",
    prev: "Poprzedni",
  },
  error: {
    page: "Nie znaleziono strony",
    return: "Powrót do poprzedniej strony",
  },
  header: {
    menuList: {
      name1: "Najlepiej sprzedające się",
      name2: "O nas",
      name3: "Urządzenia energetyczne",
      name4: "Sklep online",
      name5: "Kontakt",
      children1: {
        name1: "Mieszkania",
      },
      children3: {
        name1: "Transformatory",
        name2: "Rozdzielnice",
        name3: "Kabel średniego napięcia",
      },
    },
  },
  contact: {
    title: "Skontaktuj się z nami",
    messgage1:
      "Chętnie Ci pomożemy, zadzwoń do nas lub wyślij wiadomość. Czekamy na kontakt!",
    messgage2:
      "Zgadzam się, że ta strona przechowuje podane przeze mnie informacje, aby odpowiedzieć na moje zapytanie.",
    form: {
      title: "Wyślij nam wiadomość",
      subtitle: "Wypełnij formularz, a my skontaktujemy się z Tobą tak szybko, jak to możliwe",
      label0: "Stanowisko",
      label1: "Firma",
      label2: "Imię i nazwisko",
      label3: "E-mail",
      label4: "Telefon",
      label5: "Wiadomość",
      label6: "Zgoda RODO",
      placeholder0: "np. Kierownik projektu",
      placeholder1: "Nazwa Twojej firmy",
      placeholder2: "Twoje pełne imię i nazwisko",
      placeholder3: "twoj.email@example.pl",
      placeholder4: "+48 123 456 789",
      placeholder5: "Powiedz nam, jak możemy Ci pomóc...",
    },
    info: {
      address: "Adres",
      phone: "Telefon",
      email: "E-mail",
      hours: "Godziny pracy",
      workdays: "Poniedziałek - Piątek",
      time: "9:00 - 18:00",
    },
    button: "Wyślij wiadomość",
  },
  top3: {
    tit1: {
      title: 'Inwerter hybrydowy X3',
      text: 'Inwerter hybrydowy SolaX X3, dostępny w wariantach od 5 kW do 15 kW, charakteryzuje się sprawnością do 97,5% podczas ładowania i rozładowania. Oferuje 200% przewymiarowania dla systemów PV i do 110% przeciążenia wyjścia AC. Dzięki funkcji śledzenia cienia, ekonomicznej pracy i wsparciu dla wydajnych modułów słonecznych (do 150% wejścia PV), efektywnie magazynuje energię z PV do baterii. Bezpieczny dzięki ochronie IP65 i zabezpieczeniu przepięciowemu, oferuje inteligentną technologię szybkiego przełączania w czasie poniżej 10 milisekund, kompatybilność z bateriami litowo-jonowymi i kwasowo-ołowiowymi oraz szybką reakcję na obciążenie (0,3 sekundy).'
    },
    tit2: {
      title: 'INTELIGENTNA ŁADOWARKA DO POJAZDÓW ELEKTRYCZNYCH',
      text: 'Inteligentna ładowarka do pojazdów elektrycznych SolaX oferuje zaawansowane opcje ładowania dla pojazdów elektrycznych. Dostępna w trzech modelach: X1-EVC-7.2K, X3-EVC-11K i X3-EVC-22K, umożliwia elastyczne opcje ładowania. Ładowarka jest przyjazna dla użytkownika, z wybieranymi wtyczkami lub gniazdami do łatwej instalacji i nadaje się do użytku wewnątrz i na zewnątrz. Oferuje inteligentną kontrolę równoważenia obciążenia i pozwala ustawiać liczniki czasu, aby wykorzystać taryfy szczytowe i pozaszczytowe. Dostępne są trzy tryby ładowania: Tryb zielony, który wykorzystuje energię PV, Tryb szybki dla maksymalnej prędkości ładowania i Tryb ECO dla ustalonej mocy. Zdalne monitorowanie i sterowanie odbywa się za pośrednictwem przyjaznej dla użytkownika aplikacji.'
    },
    tit3: {
      title: 'Bateria T30',
      text: 'Bateria T30 firmy SolaX, część serii Triple Power, oferuje najnowocześniejsze rozwiązanie do magazynowania energii słonecznej. Jest dostępna w różnych pojemnościach od 3,3 kWh do 17,6 kWh i nadaje się zarówno do instalacji nisko-, jak i wysokonapięciowych. Jej duża pojemność magazynowa umożliwia długoterminowe magazynowanie energii słonecznej, zmniejszając zależność od sieci. Bateria wykorzystuje zaawansowaną technologię litowo-żelazowo-fosforanową zapewniającą wysoką gęstość energii i długowieczność. Ponadto system jest modułowy i rozszerzalny, dzięki czemu klienci mogą dodawać dodatkowe baterie w miarę wzrostu ich potrzeb magazynowych. Przyjazne dla użytkownika oprogramowanie umożliwia łatwe monitorowanie i kontrolę zużycia energii.'
    }
  },
  airset: {
    breadcrumb: {
      home: 'Strona główna',
      products: 'Centrum produktów',
      current: 'RM AirSeT™'
    },
    hero: {
      title: 'RM AirSeT™',
      subtitle: 'Bezobsługowa SF6 kompaktowa lub rozszerzalna rozdzielnica pierścieniowa z izolacją gazową do dystrybucji wtórnej do 24 kV / 630 A / 20 kA'
    },
    products: {
      title: 'Gama Produktów',
      subtitle: 'Trzy warianty dla różnych wymagań aplikacyjnych',
      view3d: 'Zobacz model 3D',
      p1: {
        name: 'RM AirSeT™ Compact',
        subtitle: 'Rozwiązanie Kompaktowe',
        desc: 'Kompaktowa, wstępnie skonfigurowana rozdzielnica dla standardowych sieci pierścieniowych. Idealna dla ograniczeń przestrzennych w obszarach miejskich.',
        specs: 'do 24 kV | 630 A | 20 kA',
        badge: 'Oszczędność miejsca'
      },
      p2: {
        name: 'RM AirSeT™ Active Plus',
        subtitle: 'Wariant Rozszerzalny',
        desc: 'Modułowy system z elastycznymi opcjami rozbudowy. Idealny dla rosnących potrzeb energetycznych i przyszłych etapów rozbudowy.',
        specs: 'do 24 kV | 630 A | 20 kA',
        badge: 'Zalecane'
      },
      p3: {
        name: 'RM AirSeT™ Digital',
        subtitle: 'Wersja Inteligentna',
        desc: 'W pełni zdigitalizowana rozdzielnica z czujnikami IoT i integracją EcoStruxure™ dla aplikacji inteligentnych sieci.',
        specs: 'do 24 kV | 630 A | 20 kA',
        badge: 'Smart Grid'
      }
    },
    overview: {
      badge: 'Wolna od SF6',
      title: 'Rozdzielnica z Izolacją Gazową dla Zrównoważonej Dystrybucji Energii',
      desc: 'RM AirSeT™ to ekologiczna, wolna od SF6 rozdzielnica z izolacją gazową (GIS) firmy Schneider Electric. Wykorzystując czyste powietrze jako medium izolacyjne, oferuje zrównoważone rozwiązanie dla sieci pierścieniowych średniego napięcia. Zaprojektowana jako kompaktowa lub rozszerzalna, jest idealna do wtórnej dystrybucji energii w środowiskach miejskich i przemysłowych.',
      features: {
        f1: {
          title: '100% Wolna od SF6',
          desc: 'Izolacja czystym powietrzem, brak szkodliwych gazów cieplarnianych'
        },
        f2: {
          title: 'Kompaktowa i Elastyczna',
          desc: 'Oszczędna konstrukcja, rozszerzalna według potrzeb'
        },
        f3: {
          title: 'Technologia Pierścieniowa',
          desc: 'Niezawodne rozwiązanie dla sieci dystrybucji wtórnej'
        }
      }
    },
    model3d: {
      title: 'Zobacz model 3D',
      description: 'Poznaj RM AirSeT™ w interaktywnym widoku 360°',
      button: 'Otwórz model 3D'
    },
    merkmale: {
      title: 'Zalety',
      subtitle: 'Innowacyjna technologia dla zrównoważonej dystrybucji energii',
      m1: {
        title: 'Zrównoważony Rozwój',
        desc: 'Czyste powietrze jako medium izolacyjne - zerowa emisja gazów cieplarnianych, GWP = 1',
        advantages: [
          'Izolacja powietrzna + wyłącznik próżniowy (bez gazów F)',
          'Zerowy potencjał ocieplenia globalnego (brak kosztów utylizacji)'
        ]
      },
      m2: {
        title: 'Bezpieczeństwo',
        desc: 'Oszczędna konstrukcja do środowisk miejskich i ograniczonych przestrzeni',
        advantages: [
          'Obudowa IP67 (izolacja odporna na warunki otoczenia)',
          'Przełącznik 3-pozycyjny + SVI™ (przełączanie wolne od toksyn)',
        ]
      },
      m3: {
        title: 'Niezawodność',
        desc: 'Elastycznie rozszerzalna zgodnie z przyszłymi wymaganiami energetycznymi',
        advantages: [
          'Jakość 40 lat (ponad 5 mln zainstalowanych jednostek)',
          'Szczelny zbiornik IP67 (bezobsługowy przez całe życie)'
        ]
      },
      m4: {
        title: 'Elastyczność',
        desc: 'Takie same standardy bezpieczeństwa jak rozdzielnice SF6, w pełni przetestowane',
        advantages: [
          '1-4 jednostki w 1 obudowie (kompaktowa powierzchnia)',
          'Konfigurowalne zestawy przewodowe (2 wysokości dla rozdzielnic/cokołów)'
        ]
      },
      m5: {
        title: 'Łączność',
        desc: 'Trwałe komponenty, obniżone koszty eksploatacji w całym cyklu życia',
        advantages: [
          'Integracja IT/OT (monitorowanie w czasie rzeczywistym)',
          'Modele 3D + połączenie DMS (wsparcie konserwacji predykcyjnej)',
        ]
      },
      m6: {
        title: 'Gotowa na Cyfryzację',
        desc: 'Kompatybilna z EcoStruxure™ dla inteligentnego zarządzania energią i zdalnego monitorowania',
        advantages: [
          'Integracja z EcoStruxure™',
          'Dostępne czujniki IoT',
        ]
      }
    },
    benefits: {
      title: 'Twoje Korzyści',
      subtitle: 'Zrównoważona, bezpieczna i przyszłościowa',
      b1: {
        title: 'Neutralna Klimatycznie',
        desc: 'Zerowa emisja SF6, GWP = 1, spełnia rozporządzenie F-Gas i cele Zielonego Ładu'
      },
      b2: {
        title: 'Sprawdzona Technologia',
        desc: 'Przetestowana technologia izolacji powietrzem z tym samym poziomem bezpieczeństwa co rozdzielnice SF6'
      },
      b3: {
        title: 'Niskoobsługowa',
        desc: 'Trwała konstrukcja, obniżone koszty eksploatacji przez cały cykl życia'
      },
      b4: {
        title: 'Przyszłościowa',
        desc: 'Spełnia przyszłe przepisy środowiskowe, brak ograniczeń w użytkowaniu'
      }
    },
    applications: {
      title: 'Obszary Zastosowań',
      subtitle: 'Wszechstronne zastosowania w dystrybucji średniego napięcia',
      a1: {
        title: 'Budynki Mieszkalne i Komercyjne',
        desc: 'Zasilanie kompleksów mieszkalnych, biurowców i centrów handlowych'
      },
      a2: {
        title: 'Przemysł',
        desc: 'Dystrybucja energii dla zakładów produkcyjnych i wytwórczych'
      },
      a3: {
        title: 'Infrastruktura Krytyczna',
        desc: 'Niezawodne zasilanie szpitali, centrów danych i obiektów publicznych'
      },
      a4: {
        title: 'Przedsiębiorstwa Energetyczne',
        desc: 'Dystrybucja wtórna w sieciach pierścieniowych zakładów energetycznych i operatorów sieci'
      },
      a5: {
        title: 'Energia Odnawialna',
        desc: 'Przyłączenie do sieci i dystrybucja projektów energii słonecznej i wiatrowej'
      },
      a6: {
        title: 'Transport i Komunikacja',
        desc: 'Zasilanie stacji kolejowych, systemów metra i lotnisk'
      }
    },
    specs: {
      title: 'Specyfikacje Techniczne',
      subtitle: 'Wysokowydajne parametry dla najwyższych wymagań',
      electrical: {
        title: 'Dane Elektryczne',
        voltage: 'Napięcie Znamionowe',
        voltage_val: 'do 24 kV',
        current: 'Prąd Znamionowy',
        current_val: 'do 630 A',
        shortCircuit: 'Wytrzymałość Zwarciowa',
        shortCircuit_val: 'do 20 kA',
        insulation: 'Medium Izolacyjne',
        insulation_val: 'Czyste Powietrze (wolne od SF6)'
      },
      environmental: {
        title: 'Dane Środowiskowe',
        gwp: 'Potencjał Cieplarnianego (GWP)',
        gwp_val: '1 (Powietrze)',
        temp: 'Temperatura Pracy',
        temp_val: '-5°C do +40°C',
        protection: 'Stopień Ochrony',
        protection_val: 'IP2X / IP3X',
        altitude: 'Maks. Wysokość Pracy',
        altitude_val: 'do 1000 m n.p.m.'
      },
      mechanical: {
        title: 'Dane Mechaniczne',
        dimensions: 'Konstrukcja',
        dimensions_val: 'Kompaktowa / Rozszerzalna',
        installation: 'Instalacja',
        installation_val: 'Wewnętrzna',
        lifespan: 'Żywotność',
        lifespan_val: '> 30 lat',
        maintenance: 'Konserwacja',
        maintenance_val: 'Niskoobsługowa'
      }
    },
    features: {
      title: 'Funkcje Cyfrowe',
      f1: {
        title: 'Gotowa na EcoStruxure™',
        desc: 'Pełna kompatybilność z platformą EcoStruxure™ dla zarządzania energią opartego na IoT'
      },
      f2: {
        title: 'Inteligentne Monitorowanie',
        desc: 'Opcjonalne czujniki i urządzenia pomiarowe do monitorowania stanu i zarządzania obciążeniem'
      },
      f3: {
        title: 'Usługi Cyfrowe',
        desc: 'Usługi analityczne w chmurze dla konserwacji predykcyjnej i optymalizacji operacyjnej'
      },
      f4: {
        title: 'Dostęp Zdalny',
        desc: 'Bezpieczna zdalna diagnostyka i konfiguracja dla maksymalnej dostępności'
      }
    },
    cta: {
      title: 'Przyszłość Dystrybucji Energii jest Wolna od SF6',
      desc: 'RM AirSeT™ łączy sprawdzoną technologię rozdzielnic z ekologiczną innowacją. Skontaktuj się z nami w celu indywidualnej konsultacji dotyczącej Twojego zrównoważonego rozwiązania średniego napięcia.',
      btn1: 'Zapytaj o Konsultację',
      btn2: 'Pobierz Katalog Produktu'
    }
  }
};
export default pl;
